import Wifi from '@appblocks/codegeneration/Features/Wifi';
import WifiMicropython from '@appblocks/codegeneration/Features/WifiMicropython';
import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import BoardSetting from '@appblocks/codegeneration/Features/BoardSetting';
import Net from '@appblocks/codegeneration/Features/Net';
import Bluetooth from '@appblocks/codegeneration/Features/Bluetooth';
import HTTPServer from '@appblocks/codegeneration/Features/HTTPServer';
import Socket from '@appblocks/codegeneration/Features/Socket';
import Fd from '@appblocks/codegeneration/Features/Fd';
import General from '@appblocks/codegeneration/Features/General/General';
import NtiosGeneral from '@appblocks/codegeneration/Features/General/NtiosGeneral';
import ArduinoGeneral from '@appblocks/codegeneration/Features/General/ArduinoGeneral';
import MicroPythonGeneral from '@appblocks/codegeneration/Features/General/MicroPythonGeneral';
import ZephyrGeneral from '@appblocks/codegeneration/Features/General/ZephyrGeneral';
import Cellular from '@appblocks/codegeneration/Features//Cellular';
import LCD from '@appblocks/codegeneration/Features//LCD';
import WifiWM2000 from '@appblocks/codegeneration/Features//WifiWM2000';
import WM2000LightSensor from '@appblocks/codegeneration/Features/WM2000LightSensor';
import WM2000TempSensor from '@appblocks/codegeneration/Features/WM2000TempSensor';
import Timers from '@appblocks/codegeneration/Features/Timers';
import WM2000PWMLED from '@appblocks/codegeneration/Features/WM2000PWMLED';
import GlobalVariables from '@appblocks/codegeneration/Features/GlobalVariables';
import WebDashboard from '@appblocks/codegeneration/Features/WebDashboard';
import Beep from '@appblocks/codegeneration/Features/Beep/Beep';
import UnoWireSensors from '@appblocks/codegeneration/Features/UnoWireSensors';
import ProjectConfiguration from '@appblocks/codegeneration/ProjectConfiguration';
import WirelessModule from '@appblocks/codegeneration/Features/WirelessModule';
import BeepNtios from '@appblocks/codegeneration/Features/Beep/BeepNtios';
import Commands from '@appblocks/codegeneration/Features/Commands';
import FirmwareUpgrade from '@appblocks/codegeneration/Features/FirmwareUpgrade';
import Keypad from '@appblocks/codegeneration/Features/Keypad';
import DSOLED from '@appblocks/codegeneration/Features/DSOLED';
import CustomFeatures from '@appblocks/codegeneration/Features/CustomFeatures';
import WifiZephyr from '@appblocks/codegeneration/Features/WifiZephyr';
import PeripheralWiring from '@appblocks/codegeneration/Features/PeripheralWiring';

// These are features that are available and can be enabled without adding
// to project (Shown in features tab)
const FeaturesMap: { [featureId: string]: any } = {
    net: Net,
    wifi: {
        tios: Wifi,
        micropython: WifiMicropython,
        zephyr: WifiZephyr,
        simulator: Wifi,
    },
    wifiwm2000: WifiWM2000,
    general: {
        tios: General,
        ntios: NtiosGeneral,
        arduino: ArduinoGeneral,
        micropython: MicroPythonGeneral,
        zephyr: ZephyrGeneral,
        simulator: General,
    },
    bt: Bluetooth,
    cell: Cellular,
    httpserver: HTTPServer,
    socket: Socket,
    boardsetting: BoardSetting,
    fd: Fd,
    lcd: LCD,
    wm2000ev_light: WM2000LightSensor,
    wm2000ev_temp: WM2000TempSensor,
    wm2000ev_pwm_led: WM2000PWMLED,
    global_vars: GlobalVariables,
    web_dashboard: WebDashboard,
    firmware_upgrade: FirmwareUpgrade,
    timers: Timers,
    unowiresensors: UnoWireSensors,
    beep: Beep,
    commands: Commands,
    wireless_module: WirelessModule,
    kp: Keypad,
    ds_oled: DSOLED,
    custom_features: CustomFeatures,
    peripheral_wiring: PeripheralWiring,
};

export default class Features {
    static getItem(itemId: string, project: ProjectConfiguration) {
        if (FeaturesMap[itemId] !== undefined) {
            if (project.runtime
                && FeaturesMap[itemId][project.runtime] !== undefined) {
                return new FeaturesMap[itemId][project.runtime]();
            }
            try {
                return new FeaturesMap[itemId]();
            } catch (e) {
                return undefined;
            }
        }

        return undefined;
    }

    static getList() {
        return Object.keys(FeaturesMap);
    }
}
